import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const SuccessContainer = styled(Box)(({ theme }) => ({
  border: `1px solid rgba(34, 197, 94, 0.3)`,
  borderRadius: theme.spacing(1),
  backgroundColor: "rgba(34, 197, 94, 0.05)",
  overflow: "hidden",
  marginTop: theme.spacing(1),
  minHeight: "56px",
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(1.5, 2),
  gap: theme.spacing(1.5),
  animation: "fadeIn 0.3s ease-in-out",
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(-10px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
}));

interface SuccessConfirmationProps {
  readonly keyword: string;
}

const SuccessConfirmation: React.FC<SuccessConfirmationProps> = ({
  keyword,
}) => {
  return (
    <SuccessContainer>
      <CheckCircleIcon sx={{ fontSize: 20, color: "#22c55e", flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          variant="body2"
          sx={{
            color: "#22c55e",
            fontWeight: 600,
            lineHeight: 1.2,
            fontSize: "0.875rem",
          }}
        >
          ✅ Great choice! No existing ranking found
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: "#6b7280",
            fontSize: "0.75rem",
            display: "block",
          }}
        >
          "{keyword}" is available for new content creation
        </Typography>
      </Box>
    </SuccessContainer>
  );
};

export default SuccessConfirmation;